// extracted by mini-css-extract-plugin
module.exports = {"container":"cd01fbf7b5--container--VuLqP","phone":"cd01fbf7b5--phone--rI2nz"};